import { MSG_CONFIRM_INPUT_CHANGE_NOT_UPDATED } from "../common/message";

export const ON_INPUT_INVALID_INTEGER = "数字またはカンマ(,)で入力してください";
export const ON_INPUT_INVALID_DECIMAL =
  "有効な整数または小数で入力してください";

export const validateInteger = (val) => {
  let match = val.match(/^[0-9,\uff10-\uff19\u002c]+$/g);
  return Boolean(match) && match.length > 0;
};

export const validateIntegerOrEmpty = (val) => {
  return val === "" || validateInteger(val);
};

export const validateDecimal = (val) => {
  let match = val.match(
    /^[0-9\uff10-\uff19\u002c]+[.\uff0e]*[0-9\uff10-\uff19]*$/g
  );
  return Boolean(match) && match.length > 0;
};

export const validateDecimalOrEmpty = (val) => {
  return val === "" || validateDecimal(val);
};

/**
 * 入力チェック：必須
 *
 * @param val チェック対象
 */
export const isNullEmpty = (val) => {
  if (val == "" || val === undefined || val == null) {
    return true;
  }
  return false;
};

/**
 * 入力チェック：必須
 *
 * @param val チェック対象
 */
export const isNullObject = (val) => {
  return val && Object.keys(val).length === 0 && val.constructor === Object;
};

/**
 * 画面の入力情報が変更されていたら確認メッセージを出力して確認する
 * @return Boolean 未変更 もしくは 確認メッセージOK押下
 */
export const confirmWhenChanged = (isChanged) => {
  return !isChanged || window.confirm(MSG_CONFIRM_INPUT_CHANGE_NOT_UPDATED);
};

// Check if value is not null
export function isNotNull(value) {
  if (value === "" || value === undefined || value == null) {
    return false;
  }
  return true;
}

// Check if value is a number
export function isNumber(value) {
  return isNotNull(value) && !isNaN(Number(value));
}

// Check if value is a number or null
export function isNumberOrNull(value) {
  if (!value) return true;
  return !isNaN(Number(value));
}

// export function isValidTelNumber(value) {
//   if (!value) return true;
//   const pattern =
//     /^(?:\d{10}|\d{3}-\d{3}-\d{4}|\d{2}-\d{4}-\d{4}|\d{3}-\d{4}-\d{4}|\d{4}-\d{2}-\d{4})$/; // Adjust the pattern as per your requirements
//   return pattern.test(value);
// }
export function isValidJapanTelNumber(value) {
  if (!value) return true;
  const pattern =
    /^(?:\d{10}|\d{11}|\d{3}-\d{3}-\d{4}|\d{2}-\d{4}-\d{4}|\d{3}-\d{4}-\d{4}|\d{4}-\d{2}-\d{4})$/;
  return pattern.test(value);
}

export function isValidEmail(value) {
  if (!value) return true;
  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return pattern.test(value);
}

//ポストハイフン入るのもOK
// export function isValidPostalCode(value) {
//   if (!value) return true;
//   const pattern = /^[0-9]{3}-?[0-9]{4}$/; // Adjust the pattern based on your country's postal code format
//   return pattern.test(value);
// }

export function isValidPostalCode(value) {
  if (!value) return true;
  const pattern = /^[0-9]{7}$/; // Exactly 7 digits, nothing else
  return pattern.test(value);
}

// Check if the length of the value falls within the given range (min and max)
export function lengthValid(value, min, max) {
  if (typeof value !== "string" && !(value instanceof Array)) {
    throw new Error("Value must be a string or array to check its length");
  }
  return value.length >= min && value.length <= max;
}

// Check if a string does not include "-"
export function stringDoesNotIncludeDash(value) {
  if (!value) return true;
  return !value.includes("-");
}
